<script setup lang="ts">
import ModelTable from '@/components/business/crud/common/ModelTable.vue';
import { computed, defineProps, inject } from 'vue';
import { HasManyFieldType } from '@/components/business/crud/interface/FieldType';
import { request } from '@/util/request';
import { WindowTool } from '@/components/common/window/WindowInterface';

const props = defineProps<{
  propName: string;
  widget: HasManyFieldType;
  info: {
    status: 'edit' | 'show';
    title: string;
  };
  data: any;
}>();

const condition = computed(() => {
  return {
    [props.widget.targetPropName]: {
      [props.widget.localPrimary]: props.data[props.widget.localPrimary],
    },
  };
});
const attachCondition = computed(() => {
  return {
    [props.widget.targetPropName]: {
      $nor: {
        [props.widget.localPrimary]: props.data[props.widget.localPrimary],
      },
    },
  };
});
const windowTool = inject<WindowTool | false>(WindowTool, false);

async function onChange(op: 'attach' | 'detach', rows?: any[]) {
  if (!rows || rows.length === 0) {
    return;
  }
  const res = await request(
    `/${props.widget.localModuleName}/${props.widget.localController}/update`,
    {
      id: props.data[props.widget.localPrimary],
      data: {
        [props.propName]: {
          [op]: rows.map((row: any) => row[props.widget.targetPrimary]),
        },
      },
    }
  );
  if (windowTool) {
    windowTool.setReturnData(true);
  }
  return res;
}
</script>

<template>
  <div>
    <model-table
      :status="info.status"
      :title="info.title"
      :module-name="widget.targetModuleName"
      :controller-name="widget.targetController"
      :label-name="widget.targetLabel"
      :condition="condition"
      :attach-condition="attachCondition"
      :hidden-fields="[widget.targetPropName]"
      :on-change="onChange"
    />
  </div>
</template>

<style scoped lang="scss"></style>
